/* eslint-disable no-use-before-define */
import React from 'react';
import  ReactDropDownAutoComplete  from 'react-dropdown-autocomplete';
import { getlanguagelist } from "../../helpers/changelanguage";
import './common.css';


export default function ProfileFriendListDropdown(prop) {
    let  languagelist    = getlanguagelist();
    const editFields = {name:''};
    const dataList = prop.dataList;
    const onchange = (vall) => {
      
    let matchedIndex = dataList.map(function (obj) { return obj.full_name; }).indexOf(vall);
      if(matchedIndex >= 0){
          let newObj = {
              id    : dataList[matchedIndex].id,
              name :  vall
          }
          prop.changeHandeler(newObj);
      }else{
          let newObj = {
              id    : vall,
              name :  vall
          }
          prop.changeHandeler(newObj);
      }
    }

    const clearVal =()=>{
      document.getElementById('friend_name').value = ''
      let newObj = {
        id    : null,
        name : null
       }
      prop.changeHandeler(newObj);
    }

  return (
    <ReactDropDownAutoComplete
        getItemValue={item => item.full_name}
        className="form-control"
        id="friend_name"
        name="friend_name"
        placeholder={`${(prop.addmoreTitle== 'Education') ? `${languagelist.education}` : `${languagelist.searchfrnd}`}`}
        data={dataList || []}
        renderItem={item => (
          <div
            role="button"
            tabIndex="-1"
            onClick={(val) => { editFields.name = val; }}
          ><img src={item.image} className="dropdownUserImg"/> {item.full_name} </div>
        )}
        icon="ban"
        iconColor="#ec5555"
        iconClick={() => clearVal()}
        value={prop.defaultVal}
        onChange={(val) => onchange(val)}
        onEnter={() => { /* TODO */ }}
      />
  );
}

